import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import messages from './messages';
import { MediumActionButton } from '../UIKit';
import Print from '-!svg-react-loader!./assets/img/print.svg?name=Print';
import { default as PrintForm } from '../Forms/';
import './styles.scss';

class OfferPrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      print: false,
    };
    this.onPrintClick = this.onPrintClick.bind(this);
  }

  onPrintClick() {
    this.setState({
      print: !this.state.print,
    });
  }

  render() {
    const { carName } = this.props;

    return (
      <div id="OfferPrint">
        <div className="title">
          <FormattedMessage {...messages.title} />
        </div>
        <div className="text-center">
          <MediumActionButton
            text={messages.button.defaultMessage}
            icon={<Print />}
            onClick={this.onPrintClick}
          />
        </div>
        <Modal
          isOpen={this.state.print}
          toggle={this.onPrintClick}
          className="right-side-modal OfferPrint"
        >
          <ModalHeader
            toggle={this.onPrintClick}
          >{`Stampa Offerta ${carName}`}</ModalHeader>
          <ModalBody>{this.state.print && <PrintForm />}</ModalBody>
        </Modal>
      </div>
    );
  }
}

OfferPrint.defaultProps = {};

OfferPrint.propTypes = {
  carName: PropTypes.string.isRequired,
};

export default OfferPrint;
